import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRInput } from '@base/src/app/models/qr-input.model';
import { QRTextarea } from '@base/src/app/models/qr-textarea.model';
import { BodySimpleUpdate } from '../../../models/update-simple.model';

type InputTypes = string | number | undefined;

@Component({
  selector: 'app-simple-update-request',
  templateUrl: './simple-update-request.component.html',
  styleUrls: ['./simple-update-request.component.scss'],
})
export class SimpleUpdateRequestComponent implements OnInit {
  @Input() textAreaValue: string | undefined;
  @Input() ccValue!: string;
  @Input() workEmailValue!: string;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() request: EventEmitter<BodySimpleUpdate> = new EventEmitter<BodySimpleUpdate>();
  

  requestBody!: BodySimpleUpdate;
  subjectValue: string = 'Solicitud de Update de Reservas';

  inputString: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
  };

  textArea: QRTextarea = {};

  buttonCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar',
  };

  buttonConfirm: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Confirmar',
  };

  ngOnInit(): void {
    this.requestBody = {
      to : this.workEmailValue,
      cc: this.ccValue,
      subject: this.subjectValue,
      message: this.textAreaValue ?? ''
    }
  }

  changeInputTo(value: InputTypes): void {
     this.requestBody.to = String(value ?? "");
  }

  changeInputCc(value: InputTypes): void {
    this.requestBody.cc = String(value ?? "");
  }

  changeInputSubject(value: InputTypes): void {
    this.requestBody.subject = String(value ?? "");
  }

  textareaChange(value: string | undefined): void {
    this.requestBody.message = value ?? '';
  }

  requestSimple(): void {
    this.request.emit(this.requestBody);
  }
}
